var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertNotice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#5371D5",
    strokeWidth: 2,
    d: "M3.786 15.653l-1.654-4.547c-1.017-2.792-.354-5.68 2.06-7.259l-.224-.618a1.46 1.46 0 01.888-1.868 1.46 1.46 0 011.88.86l.226.618c2.873-.345 5.225 1.435 6.244 4.236l1.655 4.547 2.508 1.147.331.91-14.766 5.374-.331-.91 1.183-2.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5371D5",
    d: "M11.31 19.094c-1.015.37-2.144-.147-2.508-1.147l3.692-1.344c.364 1-.16 2.118-1.184 2.49z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertNotice);
export default __webpack_public_path__ + "assets/images/alert-notice.3ae41ad25c18b4df02920580a4b58621.svg";
export { ForwardRef as ReactComponent };